import React, { memo, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { EntityFiltersActions, ValueListActions } from 'actions';

import SingleNode from 'components/TreeNavigatorNew/SingleNode';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { CAMPAIGNS } from 'constants/Entities';
import {
    Campaigns,
    EditFilled,
    OnGoing,
    Agenda,
    ThickEnabledDefault,
} from 'components/SvgIcons/index';

function mapStateToProps(state) {
    let filters = state.entityFilters[CAMPAIGNS.entity] || {};
    filters = filters ? filters.filters || {} : {};

    let statusFilter = filters.statusId || {};
    let statusValue = statusFilter.value || '';
    let valueList = state.valueList;
    let campaignStatuses = valueList['tblCampaignsStatuses']?.data ?? [];
    return {
        statusValue,
        campaignStatuses,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeFilter: bindActionCreators(EntityFiltersActions, dispatch).changeFilter,
        getValueList: bindActionCreators(ValueListActions, dispatch).getValueList,
    };
};

const ContentNavigator = memo(({ statusValue, campaignStatuses, changeFilter, getValueList }) => {
    useEffect(() => {
        if (!campaignStatuses || campaignStatuses.length === 0) {
            getValueList('tblCampaignsStatuses');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onClick = useCallback(
        (value) => () => {
            const filter = {
                dataType: 'text',
                id: 'statusId',
                hideForCount: true,
            };
            changeFilter && changeFilter({ entity: CAMPAIGNS, filter, value: parseInt(value, 10) });
        },
        [changeFilter],
    );

    const renderStatuses = () => {
        return (
            <div>
                {campaignStatuses
                    .sort((a, b) => a['-id'] > b['-id'])
                    .map((status) => {
                        let id = status['-id'];
                        let text = status['descripcion'];
                        let icon;
                        switch (id) {
                            case '1':
                                icon = <EditFilled />;
                                break;
                            case '2':
                                icon = <OnGoing />;
                                break;
                            case '3':
                                icon = <Agenda />;
                                break;
                            case '4':
                                icon = <ThickEnabledDefault />;
                                break;
                            default:
                                return;
                        }

                        return (
                            <SingleNode
                                key={id}
                                icon={icon}
                                text={text}
                                isSelected={String(statusValue) === id}
                                onClick={onClick(id)}
                            />
                        );
                    })}
            </div>
        );
    };

    return (
        <div id="campaigns-navigator" className="campaigns-navigator">
            <SingleNode
                icon={<Campaigns />}
                text={<Literal literal="label_campaigns_list_all_statuses" />}
                isSelected={statusValue === ''}
                onClick={onClick('')}
            />
            <div className="navigator-separator" />
            {renderStatuses()}
        </div>
    );
});

ContentNavigator.displayName = 'ContentNavigator';

export default connect(mapStateToProps, mapDispatchToProps)(ContentNavigator);
